module.exports = __webpack_public_path__ + "static/media/Appliance.7ae5588b.jpg";